import { render } from "./ex.vue?vue&type=template&id=48e4cd0e&scoped=true"
import script from "./ex.vue?vue&type=script&lang=js"
export * from "./ex.vue?vue&type=script&lang=js"

import "./ex.vue?vue&type=style&index=0&id=48e4cd0e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e4cd0e"]])

export default __exports__